import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapLink, MapLinkText } from '../../NewSearch/NewSearchBar/styled';
import Icon from '../../Icon';
import MapIcon from '../../../public/static/images/new_search/icons/map-icon.svg';
import { RAILS_ROUTES } from '../../../utils/helpers/constants';
import { modifyUrlForLanguage } from '../../../utils/helpers/modifyUrlForLanguage';

export const ResidenceMap: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <MapLink
      href={modifyUrlForLanguage(RAILS_ROUTES.RESIDENCES_MAP, i18n.language)}
      target="_blank"
      rel="noopener noreferrer"
      data-cy="residences-map-link"
      data-stat="view-on-map"
    >
      <Icon IconComponent={MapIcon} width={20} height={20} indent={false} />
      <MapLinkText tag="body_1">{t('new_search.map')}</MapLinkText>
    </MapLink>
  );
};
